<template>
  <transition name="modal">
    <div ref="firstSignInModalMask" class="modal-mask" style="visibility:hidden;">
      <div class="modal-wrapper" @click.self="didTapOutOfModal">
        <div class="first-sign-in-modal-container">
          <card>
            <div class="cancel-row">
              <img src="@/assets/static/img/x.png" alt="..." @click="didTapCancel" />
            </div>
            <div class="content-row">
              <div class="content-wrapper">
                <div class="row">
                  <div class="col-lg-5">
                    <div class="text-wrapper">
                      <div class="welcome-title">{{ welcome_title }}</div>
                      <div class="welcome-description">{{ welcome_description }}</div>
                      <div class="welcome-steps">
                        <div>{{ step_1 }}</div>
                        <div>
                          {{ step_2 }}<span class="link" @click="didTapFirstRewards">{{ step_2_link }}</span>
                        </div>
                      </div>
                      <div class="welcome-followup">{{ welcome_followup }}</div>
                    </div>
                  </div>
                  <div class="col-lg-7">
                    <div class="wistia-wrapper">
                      <span class="wistia_embed wistia_async_qnt4vsvq2f videoFoam=true"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      Card,
    },
    computed: {
      welcome_title () {
        return `Thanks, ${this.$store.getters.user.first_name}!`
      }
    },
    data: function () {
      return {
        welcome_description: 'Welcome to your Dashboard! Just a few more steps until you’re up and running:',
        step_1: '1. Watch our video tutorial',
        step_2: '2. Create your ',
        step_2_link: 'first rewards',
        welcome_followup: 'Once your rewards have been created, we’ll follow up to publish your listing.',
      }
    },
    methods: {
      didTapCancel () {
        this.$emit('hideFirstSignInModal');
      },
      didTapOutOfModal () {
        this.$emit('hideFirstSignInModal');
      },
      didTapFirstRewards () {
        this.$emit('hideFirstSignInModal');
        this.$router.push('/rewards')
      }
    },
    mounted () {
      const self = this
      setTimeout( function() {
        const wistia_media = document.createElement('script');    
        wistia_media.setAttribute('src',"https://fast.wistia.com/embed/medias/qnt4vsvq2f.jsonp");
        document.head.appendChild(wistia_media);

        const wistia_assets = document.createElement('script');    
        wistia_assets.setAttribute('src',"https://fast.wistia.com/assets/external/E-v1.js");
        document.head.appendChild(wistia_assets);

        self.$refs.firstSignInModalMask.style.visibility = "visible";
      }, 2000);
    }
  }
</script>